import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth-context.js";

/** Route guard for the app: loading → spinner; anonymous → /login. */
export function RequireAuth() {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <div style={{ minHeight: "100dvh", display: "grid", placeItems: "center" }}>
        <span aria-busy="true">Loading…</span>
      </div>
    );
  }
  if (status === "anonymous") return <Navigate to="/login" replace />;
  return <Outlet />;
}
